import { BaseReportsApi } from "../Api/apis/BaseReportsApi";
import { getAuthConfiguration } from "./configuration";
import { ReportType, BaseReportDTO, AddBaseReportDTO } from "../Api/models";

const ApiFactory = () => new BaseReportsApi(getAuthConfiguration());

export const getReportById = (id: string) => {
    if (!id) {
        throw new Error("ID is required");
    }
    return ApiFactory().apiBaseReportsGetReportByIdIdGet({ id });
};

export const getReportsByProgramId = (programId: string, reportType?: ReportType, page: number = 1, pageSize: number = 10) => {
    return ApiFactory().apiBaseReportsGetAllReportsForProgramProgramIdGet({
        programId,
        type: reportType,
        page,
        pageSize,
    });
};

export const addReport = (reportDTO: BaseReportDTO) => {
    
    return ApiFactory().apiBaseReportsCreatePost({
        baseReportDTO: reportDTO,
    });
};

export const addReportWithFile = (reportDTO: AddBaseReportDTO) => {

    return ApiFactory().apiBaseReportsCreateWithFilePost({
        reportDate: reportDTO.reportDate ?? undefined,
        studyProgramId: reportDTO.studyProgramId ?? undefined,
        file: reportDTO.file ?? undefined,
        description: reportDTO.description ?? undefined,
        reportTypeValue: reportDTO.reportType ?? undefined,
        startDate: reportDTO.startDate ?? undefined,
        recommendationsJson: reportDTO.recommendationsJson ?? undefined,
    });
};


export const updateReport = (id: string, reportDTO: BaseReportDTO) => {
    
    return ApiFactory().apiBaseReportsUpdateIdPost({
        id,
        baseReportDTO: reportDTO,
    });
};

export const deleteReport = (id: string) => {
    if (!id) {
        throw new Error("ID is required");
    }
    return ApiFactory().apiBaseReportsDeleteIdDelete({ id });
};